import { Analytics, AnalyticsConsoleLogger } from '@tumelo/analytics'
import { useRouter } from 'next/router'
import React, { createContext, use, useEffect } from 'react'
import { useGetUser } from '../features/user/useGetUser'

export const AnalyticsContext = createContext<Analytics>(AnalyticsConsoleLogger)

export const useAnalytics = () => {
  return use(AnalyticsContext)
}

const useExplicitPageView = (analytics: Analytics, page: string) =>
  useEffect(() => {
    analytics.pageView(page)
  }, [analytics, page])

export const ExplicitPageView: React.FC<React.PropsWithChildren<{ page: string }>> = ({ page, children }) => {
  const analytics = useAnalytics()
  useExplicitPageView(analytics, page)
  return <>{children}</>
}

const usePageViewFromLocationPathname = () => {
  const router = useRouter()
  const analytics = useAnalytics()
  useExplicitPageView(analytics, router.pathname)
}

/**
+ * Tracks the current page being visited by the user using Next Router.
 */
export const PageViewFromLocationPathname: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  usePageViewFromLocationPathname()
  return <>{children}</>
}

/**
 * Sets the user tag
 */
export const SetUserProperties: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const fetchUser = useGetUser()
  const analytics = useAnalytics()
  useEffect(() => {
    if (fetchUser.value) {
      analytics.setUserProperties(fetchUser.value.name)
    }
  }, [analytics, fetchUser.value])
  return <>{children}</>
}
